module.exports = "<img *ngIf=\"showRibbon\" src=\"/assets/ribbons/staging.png\" class=\"ribbon\" />\n"